





















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import FormValidator from '@/utils/form-validator'

@Component
export default class ImportDialog extends Vue {
    formValidator = new FormValidator()
    fileList: File[] = []

    @Prop() isShownDialog!: boolean

    @Prop() loading!: boolean

    // default: 5M
    @Prop({ default: 5 }) maxSize!: number

    mounted(): void {
    }

    @Emit('submit')
    submit(file: File) {
        return file
    }

    @Emit('close')
    handleClose(): void {
    }

    onOpen() {
        this.fileList = []
    }

    confirm(): void {
        const [file] = this.fileList

        const isExcel = this.isExcel(file)
        if (!isExcel) {
            this.$message.error(this.$t('documents.import.type.excel') as string)
            return
        }

        const isExceed = this.isSizeExceed(file)
        if (isExceed) {
            this.$message.error(this.$t('documents.import.size.excel', { size: this.maxSize }) as string)
            return
        }

        this.submit(file)
    }

    isExcel(file: File): boolean {
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        return extension === 'xlsx'
    }

    isSizeExceed(file: File) {
        return file.size > this.maxSize * 1024 * 1024
    }

    fileExceed() {
        this.$message.warning(this.$t('documents.import.exceed') as string)
    }

    fileChange(file: File) {
        this.fileList.push(file)
    }

    fileRemove(file: File) {
        const index = this.fileList.findIndex((item: File) => item === file)
        if (index > -1) {
            this.fileList.splice(index, 1)
        }
    }
}
